const confirmEmailWrap = document.querySelector('.js-dm-confirm-email-wrap')
function fixConfirmEmailFields (wrap) {
  const inputWrapEl = wrap.querySelectorAll('.js-form-item')
  const labelEl = wrap.querySelectorAll('.option ')


  for (var i = 0; i < inputWrapEl.length; i++) {
    // Add .form-floating on all input wrappers
    const element = inputWrapEl[i]
    element.classList.add('form-floating')
  }
  for (var i = 0; i < labelEl.length; i++) {
    // Add .form-label on all input labels
    const element = labelEl[i]
    element.classList.add('form-label')
  }

}

if (confirmEmailWrap) {
  fixConfirmEmailFields(confirmEmailWrap)
}
